import React from "react";
import styled from "styled-components";
import ImgSrc from "../../assets/avatar.png";

const StyledImg = styled.img`
  margin: 38px auto 0 auto;
  width: 184px;
  height: 183px;
`;

const AvatarImg = () => {
  return (
    <StyledImg
      className="ui image"
      alt="SafeFun Avatar"
      src={ImgSrc}
    ></StyledImg>
  );
};

export default AvatarImg;
